import PropTypes from 'prop-types';

import DividerWithCenteredText from 'components/DividerWithCenteredText';

const Divider = ({ className }) => (
  <DividerWithCenteredText
    className={className}
    colorClassName="text-neutral-high-400"
  >
    ou
  </DividerWithCenteredText>
);

Divider.propTypes = {
  className: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
};

export default Divider;
